interface FieldElement {
  readonly closest: (selector: string) => { readonly getAttribute: (name: string) => string | null } | null;
}

/** The step field a focused element edits (`data-step-field`, as a revision's diff names it), or null when it edits none. */
export function stepFieldOf(target: unknown): string | null {
  const closest = (target as Partial<FieldElement> | null)?.closest;
  if (typeof closest !== "function") return null;
  return (target as FieldElement).closest("[data-step-field]")?.getAttribute("data-step-field") || null;
}
